// 缓存默认key 前缀
export const CACHEKEY = 'ynf-core-middleware-cache';
// 缓存最大2M
export const CACHEMAXSIZE = 2048
